"use strict";

import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState
} from "react";

import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import { Box, Button, Grid, Group, Input, MultiSelect, rem } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import { IconBarcode, IconBuildingSkyscraper, IconBuildingWarehouse, IconFileExport, IconSearch } from "@tabler/icons-react";
import {
    ColDef,
    GridReadyEvent,
    ModuleRegistry
} from "ag-grid-community";
import {
    IServerSideDatasource,
    IServerSideGetRowsRequest,
    ServerSideRowModelModule
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { paginationPageSize, paginationPageSizeSelector, repositoryDelivery, repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { ProductSerialModel } from "../../../model/GetProductSerialModel";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { BASE_API_MDM } from "../../../config";



ModuleRegistry.registerModules([
    ServerSideRowModelModule
]);

const GetProductBySerial = () => {
    const [loading, setLoading] = useState(true);
    const gridRef = useRef<AgGridReact<any>>(null);
    const headerRef = React.useRef<HTMLDivElement>(null);
    const datasourceRef = useRef<IServerSideDatasource | null>(null);
    const [height, setHeight] = useState(800);
    const [dataBranchCode, setDataBranchCode] = useState<any[]>([]);
    const [dataInvCode, setDataInvCode] = useState<any[]>([]);
    const [searchCatSegment5e, setSearchCatSegment5e] = useState<string>("");
    const [debounceCatSegment5e] = useDebouncedValue<string>(
        searchCatSegment5e,
        500
    );
    const [dataCatSegment5e, setDataCatSegment5e] = useState<
        SelectListItemModel[]
    >([]);
    const [visible, { toggle, close, open }] = useDisclosure(false);
    // Xoá useState search, chỉ dùng form
    const containerStyle = useMemo(() => ({ width: "100%", height: height }), [height]);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
    const sizeGrid = { base: 12, sm: 6, md: 6, lg: 2.6 };

    useEffect(() => {
        const updateHeight = () => {
            const headerHeight = headerRef.current?.offsetHeight || 0;
            // 400 là tổng khoảng cách cần trừ (breadcrumb, filters, padding, pagination)
            const newHeight = window.innerHeight - (210 + headerHeight);
            setHeight(newHeight);
        };

        // Đợi DOM render xong rồi mới tính
        setTimeout(updateHeight, 0);
        window.addEventListener("resize", updateHeight);

        return () => {
            window.removeEventListener("resize", updateHeight);
        };
    }, []);

    // Chỗ này để làm lọc dùng form cho đỡ lag so với state
    const form = useForm<{
        keySearch: string;
        MaChiNhanh: string[];
        MaKho: string[];
        MaNhom: string[];
    }>({
        initialValues: {
            keySearch: "",
            MaChiNhanh: [],
            MaKho: [],
            MaNhom: [],
        },
    });
    const fetchData = async (request: IServerSideGetRowsRequest) => {
        try {
            const currentPageSize = gridRef.current?.api?.paginationGetPageSize() || paginationPageSize;
            const skip = request.startRow || 0;
            const take = currentPageSize;
            let url = `/api/v1/BaoCaoSanPhamCoSerial/get-list?Skip=${skip}&Take=${take}`;
            const values = form.getValues();
            if (values.MaChiNhanh && values.MaChiNhanh.length > 0) {
                values.MaChiNhanh.forEach((branchCode: string) => {
                    url += `&MaChiNhanh=${branchCode}`;
                });
            }
            if (values.MaKho && values.MaKho.length > 0) {
                values.MaKho.forEach((invCode: string) => {
                    url += `&MaKho=${invCode}`;
                });
            }
            if (values.MaNhom && values.MaNhom.length > 0) {
                values.MaNhom.forEach((maNhom: string) => {
                    url += `&MaNhom=${maNhom}`;
                });
            }
            if (values.keySearch) {
                url += `&KeySearch=${values.keySearch.trim()}`;
            }
            return await repositoryMdm.get<MessageResponse<ProductSerialModel[]>>(url);
        } catch (error) {
            console.error(error);
        }
    };
    // Call api bên server
    const getServerSideDatasource = useCallback((): IServerSideDatasource => {
        return {
            getRows: async (params) => {
                var response = await fetchData(params.request);
                // adding delay to simulate real server call
                if (response && response.success) {
                    // Tách row TOTAL ra khỏi data chính
                    const allData = response.data || [];

                    params.success({
                        rowData: allData,
                        rowCount: (response as any).totalCount,
                    });
                    setLoading(false);
                } else {
                    // inform the grid request failed
                    params.fail();
                    setLoading(false);
                }
            },
        };
    }, []);
    // Sau khi chọn tìm kiếm xong thì sẽ thực hiện click để call api này 
    const handleSearch = useCallback(() => {
        console.log("Search clicked with values:", form.getValues());
        setLoading(true);
        const api = gridRef.current?.api;
        if (!api) {
            console.log("API not ready");
            return;
        }

        // Refresh server-side cache để gọi lại getRows với filter mới
        (api as any).refreshServerSide({ purge: true });
    }, []);

    const onGridReady = useCallback((params: GridReadyEvent) => {
        // đăng datasource đúng để ag-Grid gọi getRows
        const datasource = getServerSideDatasource();
        datasourceRef.current = datasource;
        params.api.setGridOption('serverSideDatasource', datasource);
        console.log("Grid ready, datasource registered");
    }, [getServerSideDatasource]);

    const getRowId = useCallback((params: any) => {
        return params.data?.maVatTu || Math.random().toString();
    }, []);

    const getRowStyle = useCallback((params: any) => {
        if (params.node.rowPinned) {
            return {
                backgroundColor: '#e7f5ff',
                fontWeight: 700,
                fontSize: '14px',
                borderTop: '3px solid #15aabf',
            };
        }
        return undefined;
    }, []);

    // Hàm sửa lý sự kiện sắp xếp
    const handleSortChanged = useCallback(() => {
        const columnState = gridRef.current?.api?.getColumnState() || [];
        // tìm cột có sort (asc/desc)
        const sortedCol = columnState.find((c: any) => c.sort);
        if (sortedCol) {
            form.setFieldValue("SortBy", sortedCol.colId);
            form.setFieldValue("SortDirection", (sortedCol.sort || "").toUpperCase() === "ASC" ? "ASC" : "DESC");
        } else {
            form.setFieldValue("SortBy", null);
            form.setFieldValue("SortDirection", null);
        }
        // reload server-side data với sort mới
        gridRef.current?.api?.refreshServerSide?.({ purge: true });
    }, [form]);

    const [columnDefs] = useState<ColDef[]>([
        {
            field: "maVatTu", headerName: "Mã vật tư", width: 150
        },
        { field: "tenVatTu", headerName: "Tên vật tư", width: 500 },
        {
            field: "donViTinh", headerName: "Đơn vị tính", width: 150
        },
        { field: "tonCuoiSerial", headerName: "Tồn cuối serial", width: 180 },
        {
            field: "noSerial", headerName: "Serial", width: 150,
            valueFormatter: (params) => {
                if (params.value === "Co_Serial") return "Có Serial";
                if (params.value === "Khong_Serial") return "Không Serial";
                return params.value;
            }
        },
    ]);

    const defaultColDef = useMemo<ColDef>(() => {
        return {
            sortable: true,
            resizable: true,
        };
    }, []);

    // Lấy dữ liệu mã kho theo chi nhánh đã chọn
    const DataInvCode = async () => {
        const branchSearch = dataBranchCode.length > 0 && form.getValues()?.MaChiNhanh?.length > 0
            ? form.getValues()?.MaChiNhanh
                .map((branchCode: string) => {
                    const branch = dataBranchCode.find((b) => b.value === branchCode);
                    return branch ? `&BranchId=${branch.id}` : "";
                })
                .join("")
            : "";

        const take = form.getValues()?.MaChiNhanh?.length * 100;

        const res = await repositoryDelivery.get<MessageResponse<any>>(
            `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${form.getValues()?.MaChiNhanh && form.getValues()?.MaChiNhanh?.length > 0 ? take : 100
            }${branchSearch}`
        );

        if (res && res.success) {
            const result = res.data;
            const data = result
                ?.filter((item: any) => item.idBranch && item.name)
                ?.map((item: any) => ({
                    label: `${item.code} - ${item.name}`,
                    value: item.code?.toString(),
                }));
            setDataInvCode(data);
        }
    };

    // Lấy dữ liệu mã chi nhánh
    const DataBrachCode = async () => {
        try {
            const response = await repositoryPos.get(
                `api/v1/TblDmInventory/get-select-branch?auth=true`
            );
            if (response && response.success) {
                const transformedData = response.data
                    .filter((i: any) => i.att2 && i.text)
                    .map((item: any) => {
                        return {
                            value: item.att2,
                            label: item.att2 + " - " + item.text,
                            id: item.value,
                        };
                    });

                setDataBranchCode(transformedData);
            }
        } catch (error) {
            console.error(error);
            return;
        }
    };

    // Call api lấy dữ liệu mã nhóm
    const fetchCatSegment5e = async () => {
        let url = "/api/v1/TblCatSegment5e/get-list?Skip=0&Take=20";
        if (searchCatSegment5e && searchCatSegment5e.length > 0) {
            url += `&CodeString=${searchCatSegment5e}`;
        }
        const res = await repositoryPos.get<MessageResponse<any>>(url);
        if (res && res.success) {
            const dataAPI = res.data
                ?.filter((item: any) => item.codeString && item.name)
                ?.map((item: any) => ({
                    label: `${item.codeString} - ${item.name}`,
                    value: item.codeString?.toString(),
                }));
            const uniqueData = Array.from(
                new Map(
                    [...dataCatSegment5e, ...dataAPI].map((item) => [item.value, item])
                ).values()
            );
            setDataCatSegment5e(uniqueData);
        }
    };


    // ExportData Excel
    const exportDataExcel = async () => {
        open();
        try {
            let params = new URLSearchParams();
            const values = form.getValues();
            if (values.MaChiNhanh && values.MaChiNhanh.length > 0) {
                values.MaChiNhanh.forEach((branchCode: string) => {
                    params.append("MaChiNhanh", branchCode);
                });
            }
            if (values.MaKho && values.MaKho.length > 0) {
                values.MaKho.forEach((invCode: string) => {
                    params.append("MaKho", invCode);
                });
            }
            if (values.MaNhom && values.MaNhom.length > 0) {
                values.MaNhom.forEach((maNhom: string) => {
                    params.append("MaNhom", maNhom);
                });
            }
            if (values.keySearch) {
                params.append("KeySearch", values.keySearch.trim());
            }

            const url = `${BASE_API_MDM}/api/v1/BaoCaoSanPhamCoSerial/export-san-pham-co-serial${params.toString() ? `?${params.toString()}` : ""
                }`;
            const token = localStorage.getItem("token")?.replace(/"/g, "");

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/vnd.ms-excel",
                },
            });

            if (!response.ok) throw new Error("Failed to dowload file");

            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "bao-cao-ton-kho-theo-chi-nhanh.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            close();
        }
    };

    useEffect(() => {
        Promise.all([DataBrachCode()]);
    }, []);

    useEffect(() => {
        DataInvCode();
    }, [form.getValues()?.MaChiNhanh]);
    // mã nhóm
    useEffect(() => {
        fetchCatSegment5e();
    }, [debounceCatSegment5e]);
    return (
        <Box pos={"relative"} style={containerStyle}>
            <LoadingOverlayCustom visible={visible} />
            <div
                style={{
                    border: "1px solid #dee2e6",
                    padding: "10px",
                    overflowX: "hidden",
                }}
            >
                <Group justify="space-between" gap={0}>
                    <BreadcrumbLayout1 />
                    <Button
                        leftSection={<IconFileExport style={{ width: rem(14), height: rem(14) }} />}
                        onClick={exportDataExcel}
                    >
                        Export Excel
                    </Button>
                </Group>
                <Grid mt={10}>
                    <Grid.Col span={sizeGrid}>
                        <Input
                            placeholder="Nhập tìm kiếm"
                            type="text"
                            leftSection={<IconSearch size={20} color="#15aabf" />}
                            value={form.getValues().keySearch}
                            onChange={e => form.setFieldValue("keySearch", e.target.value)}
                            onKeyDown={async (e) => { if (e.key === "Enter") handleSearch(); }}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <MultiSelect
                            placeholder="Chi nhánh"
                            clearable
                            searchable
                            data={dataBranchCode}
                            value={form.getValues().MaChiNhanh}
                            onChange={v => form.setFieldValue("MaChiNhanh", v)}
                            leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <MultiSelect
                            size="sm"
                            placeholder="Mã kho"
                            searchable
                            clearable
                            data={dataInvCode}
                            value={form.getValues().MaKho}
                            onChange={v => form.setFieldValue("MaKho", v)}
                            leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <MultiSelect
                            size="sm"
                            placeholder="Nhập mã nhóm"
                            clearable
                            searchable
                            searchValue={searchCatSegment5e}
                            onSearchChange={setSearchCatSegment5e}
                            data={dataCatSegment5e}
                            value={form.getValues().MaNhom}
                            onChange={(value) =>
                                form.setFieldValue("MaNhom", value)
                            }
                            leftSection={<IconBarcode size={20} color="#15aabf" />}
                            nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 6, md: 6, lg: 0.9 }}>
                        <Button
                            color="blue"
                            variant="outline"
                            onClick={handleSearch}
                        >
                            Tìm kiếm
                        </Button>
                    </Grid.Col>
                </Grid>
            </div>
            <div style={gridStyle} className={"ag-theme-quartz"}>
                <AgGridReact<any>
                    ref={gridRef}
                    loading={loading}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    rowModelType={"serverSide"}
                    pagination={true}
                    paginationPageSize={100}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    onSortChanged={handleSortChanged}
                    onGridReady={onGridReady}
                    getRowId={getRowId}
                    getRowStyle={getRowStyle}
                    localeText={AG_GRID_LOCALE_VN}
                />
            </div>
        </Box >
    );
};
export default GetProductBySerial;
